import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledLoading = styled.div`
  height: 100px;
  width: 100px;
  position: fixed;
  display: block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  opacity: ${props => props.props.visible && props.props.overlay ? "1" : "0"};
  pointer-events: none;
  > svg {
    animation: rotate 1.5s linear infinite;
    fill: ${props => props.props.color};
    stroke: none;
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
  }
  &::before {
    opacity: ${props => props.props.visible && props.props.overlay ? ".5" : "0"};
    position: fixed;
    display: block;
    pointer-events: none;
    content: "";
    height: 200vh;
    width: 200vw;
    background-color: rgba(255, 255, 255, 1);
    top: -100vh;
    left: -100vw;
    z-index: 0;
    -webkit-transition: opacity .4s ease-in-out;
    -moz-transition: opacity .4s ease-in-out;
    -o-transition: opacity .4s ease-in-out;
    transition: opacity .4s ease-in-out;
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`;

export default function Loading (props) {
  return (
    <StyledLoading props={props}>
      <svg viewBox="0 0 100 100">
        <path stroke="none" d="M26 50A24 24 0 0 0 74 50A24 26 0 0 1 26 50" ></path>
      </svg>
    </StyledLoading>)
}

Loading.defaultProps = {
  color: "#21A0D2",
};

Loading.propTypes = {
  color: PropTypes.string,
};
